import { promiseTraverse } from "@rauricoste/core";
import {
  EventSyncInterface,
  TransportEvent,
  TransportEventSent,
} from "../../export";
import { Neo4jClient } from "./Neo4jClient";

export type Neo4jEvent<Event> = Omit<TransportEvent<Event>, "payload"> & {
  payload: string;
  stateId: string;
};

export class EventSyncNeo4jAdapter<Event> implements EventSyncInterface<Event> {
  constructor(
    public readonly neo4jClient: Neo4jClient,
    public readonly stateId: string,
    public readonly eventClassName: string
  ) {}
  async delete(): Promise<void> {
    await this.neo4jClient.write(
      `MATCH (p:${Neo4jClient.sanitizeClassLabel(
        this.eventClassName
      )}) DELETE p`,
      {}
    );
  }

  async getNewEventsFrom(timestamp: number): Promise<TransportEvent<Event>[]> {
    const { eventClassName, stateId, neo4jClient } = this;
    const events = await neo4jClient.readRecords(
      `MATCH (p:${Neo4jClient.sanitizeClassLabel(eventClassName)}) 
      WHERE p.timestamp > $timestamp 
      AND p.stateId = $stateId
      RETURN p`,
      { timestamp, stateId }
    );
    return events.map((event) => {
      const neo4jEvent = event as unknown as Neo4jEvent<Event>;
      return {
        ...neo4jEvent,
        payload: JSON.parse(neo4jEvent.payload),
      };
    });
  }

  async sendEvents(events: TransportEventSent<Event>[]): Promise<void> {
    const { neo4jClient, eventClassName, stateId } = this;
    // warning: this is not atomic
    await promiseTraverse(events, async (event) => {
      const neo4jEvent: Omit<Neo4jEvent<Event>, "timestamp"> & {
        timestamp: string;
      } = {
        ...event,
        stateId,
        payload: JSON.stringify(event.payload),
        timestamp: "timestamp()",
      };
      await neo4jClient.newNode(neo4jEvent, eventClassName, ["timestamp"]);
    });
  }
}
